(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
      })();
      (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
    //  this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
     /* this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);*/
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
    document.addEventListener('DOMContentLoaded', function () {
      const tabs = document.querySelectorAll('.tab');
      const tabContents = document.querySelectorAll('.tab-content');
      const urlParams = new URLSearchParams(window.location.search);
      const variantInUrl = urlParams.get('variant');
      const flickityElement = document.querySelector('.flick-slider');
      const slideCount = flickityElement.querySelectorAll('.flickity-slide').length;

      // Initialize Flickity and store the instance globally
      window.gallery = new Flickity(flickityElement, {
        cellAlign: 'left',
        contain: true,
        pageDots: slideCount > 1,
        prevNextButtons: slideCount > 1,
        wrapAround: true,
        autoPlay: false,
        pauseAutoPlayOnHover: true,
        adaptiveHeight: true,
        initialIndex: variantInUrl
          ? Array.from(flickityElement.querySelectorAll('.flickity-slide')).findIndex(
              (slide) => slide.dataset.variantId === variantInUrl
            )
          : 0,
      });

      function activateTab(tab, isInstant = false) {
        const variantId = tab.dataset.variantId;
        tabs.forEach((t) => t.classList.remove('active'));
        tabContents.forEach((tc) => tc.classList.remove('active'));

        tab.classList.add('active');
        document.getElementById('variant-' + variantId).classList.add('active');

        // Update Flickity slideshow to show the variant image
        const slideToSelect = flickityElement.querySelector(`.flickity-slide[data-variant-id="${variantId}"]`);
        if (slideToSelect) {
          const slideElements = Array.from(flickityElement.querySelectorAll('.flickity-slide'));
          const index = slideElements.indexOf(slideToSelect);
          if (index !== -1) {
            window.gallery.select(index, isInstant);
            console.log('slide index:', index);
          } else {
            console.log('Slide not found');
          }
        }
      }

      tabs.forEach((tab) => {
        tab.addEventListener('click', function (event) {
          event.preventDefault();
          activateTab(this);
          const newUrl = new URL(window.location);
          newUrl.searchParams.set('variant', this.dataset.variantId);
          history.pushState(null, null, newUrl.toString());
        });
      });

      // Automatically activate the tab if the variant ID is in the URL
      if (variantInUrl) {
        const tabToActivate = Array.from(tabs).find((tab) => tab.dataset.variantId === variantInUrl);
        if (tabToActivate) {
          activateTab(tabToActivate, true); // Pass true to activateTab to make the transition instant
        }
      } else {
        // Default to the first tab if no variant is specified in the URL
        if (tabs.length > 0) {
          activateTab(tabs[0], true); // Make the first tab activation instant
        }
      }

      function isIE() {
        const ua = window.navigator.userAgent;
        const msie = ua.indexOf('MSIE ');
        const trident = ua.indexOf('Trident/');

        return msie > 0 || trident > 0;
      }

      if (!isIE()) return;

      const hiddenInput = document.querySelector('#{{ product_form_id }} input[name="id"]');
      const noScriptInputWrapper = document.createElement('div');
      const variantSwitcher =
        document.querySelector('variant-radios[data-section="{{ section.id }}"]') ||
        document.querySelector('variant-selects[data-section="{{ section.id }}"]');
      noScriptInputWrapper.innerHTML = document.querySelector(
        '.product-form__noscript-wrapper-{{ section.id }}'
      ).textContent;
      variantSwitcher.outerHTML = noScriptInputWrapper.outerHTML;

      document.querySelector('#Variants-{{ section.id }}').addEventListener('change', function (event) {
        hiddenInput.value = event.currentTarget.value;
      });
    });
  
  } catch(e) { console.error(e); }
})();
      })();
